import { render, staticRenderFns } from "./InfoMessage.vue?vue&type=template&id=bfe55062&scoped=true&"
import script from "./InfoMessage.vue?vue&type=script&lang=ts&"
export * from "./InfoMessage.vue?vue&type=script&lang=ts&"
import style0 from "./InfoMessage.vue?vue&type=style&index=0&id=bfe55062&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfe55062",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})


/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import ClickOutside from 'vuetify/lib/directives/click-outside'
installDirectives(component, {ClickOutside})
